require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-melfort-townhouses.json") })
        }
      }, "path---project-melfort-townhouses");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-melfort-townhouses!./.cache/json/project-melfort-townhouses.json
// module id = 576
// module chunks = 231608221292675